export var DateFormat;
(function (DateFormat) {
    DateFormat["yyyymmddDash"] = "YYYY-MM-DD";
    DateFormat["yyyymmddSlash"] = "YYYY/MM/DD";
    DateFormat["ddmmyyyyDash"] = "DD-MM-YYYY";
    DateFormat["ddmmyyyySlash"] = "DD/MM/YYYY";
    DateFormat["mmddyyyyDash"] = "MM-DD-YYYY";
    DateFormat["mmddyyyySlash"] = "MM/DD/YYYY";
})(DateFormat || (DateFormat = {}));
